import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonState = 'initial' | 'loading' | 'success';

@Component({
  selector: 'tab-button',
  templateUrl: './tab-button.component.html',
  styleUrls: ['./tab-button.component.scss'],
})
export class TabButtonComponent {

  @Input() buttonText?: string;

  @Input() iconSrc?: string;

  @Input() isActive: boolean = false;

    
  @Input() color?: string;

  @Input() selectedColor?: string;

  @Output() buttonClick = new EventEmitter<void>();

  public currentState: ButtonState = 'initial';

  constructor() {}
    getGradientStyle(): { [key: string]: string } {
    if (this.color) {
            const gradient = `linear-gradient(
        var(--ion-shadeLight-${this.color}),
        var(--ion-color-${this.color}),
        var(--ion-shadeLight-${this.color})
      )`;
      return { 'background-image': gradient };
    }
    return {}; // Return empty object if no color is provided
  }
      getSelectedStyle(): { [key: string]: string } {
    if (this.selectedColor) {
            const gradient = `linear-gradient(
        var(--ion-shadeLight-${this.selectedColor}),
        var(--ion-color-${this.selectedColor}),
        var(--ion-shadeLight-${this.selectedColor})
      )`;
      return { 'background-image': gradient };
    }
    return {}; // Return empty object if no color is provided
  }
  async onButtonClick() {
    this.buttonClick.emit(); 
  }
}